import React from 'react';
import {Link} from 'react-router-dom'
import evnt from '../../images/blog/mujtabaprofile.jpg'
import ins1 from '../../images/recent-posts/img-4.jpg'
import ins2 from '../../images/recent-posts/img-6.jpg'
import ins3 from '../../images/recent-posts/img-5.jpg'


const SidebarWrap = () => {

    const SubmitHandler = (e) =>{
       e.preventDefault()
    }

    return(
        <div className="col col-lg-4 col-12">
            <div className="wpo-blog-sidebar">
                <div className="widget profile-widget">
                    <div className="profile-img">
                        <img src={evnt} alt="" />
                        <h2>Pir Mujtaba Farooq Gul</h2>
                        <p>Join us on the event</p>
                    </div>
                    <div className="pro-social">
                        <ul>
                            <li><a href="https://www.youtube.com/@mohrashareef1" target="_blank" rel="noopener noreferrer"><i className="ti-youtube"></i></a></li>
                            <li><a href="https://www.facebook.com/pirmujtabafarooqgulbadshah?mibextid=ZbWKwL" target="_blank" rel="noopener noreferrer"><i className="ti-facebook"></i></a></li>
                            <li><a href="https://www.twitter.com/pirmujtabafaroq" target="_blank" rel="noopener noreferrer"><i className="ti-twitter-alt"></i></a></li>
                            <li><a href="https://www.instagram.com/pirmujtabafarooqgul?igsh=OHRqbWpocWM3d3hv" target="_blank" rel="noopener noreferrer"><i className="ti-instagram"></i></a></li>
                        </ul>
                    </div>
                </div>
                {/* <div className="widget search-widget">
                    <form onSubmit={SubmitHandler}>
                        <div>
                            <input type="text" className="form-control" placeholder="Search Post.."/>
                            <button type="submit"><i className="ti-search"></i></button>
                        </div>
                    </form>
                </div> */}
                {/* <div className="widget recent-post-widget">
                    <h3>Upcoming Event</h3>
                    <div className="posts">
                        <div className="post">
                            <div className="img-holder">
                                <img src={ins1} alt=""/>
                            </div>
                            <div className="details">
                                <h4><Link to="/event-single">Many Children are suffering a lot for food.</Link></h4>
                                <span className="date">22 Sep 2021</span>
                            </div>
                        </div>
                        <div className="post">
                            <div className="img-holder">
                                <img src={ins2} alt=""/>
                            </div>
                            <div className="details">
                                <h4><Link to="/event-single">Be kind for the poor people and the kids.</Link></h4>
                                <span className="date">22 Sep 2021</span>
                            </div>
                        </div>
                        <div className="post">
                            <div className="img-holder">
                                <img src={ins3} alt=""/>
                            </div>
                            <div className="details">
                                <h4><Link to="/event-single">Be soft and kind for the poor people.</Link></h4>
                                <span className="date">22 Sep 2021</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="widget tag-widget">
                    <h3>Tags</h3>
                    <ul>
                        <li><Link to="/event-single">Salat</Link></li>
                        <li><Link to="/event-single">Quran</Link></li>
                        <li><Link to="/event-single">Books</Link></li>
                        <li><Link to="/event-single">Education</Link></li>
                        <li><Link to="/event-single">World Wide</Link></li>
                        <li><Link to="/event-single">Marriage</Link></li>
                        <li><Link to="/event-single">Hajj</Link></li>
                        <li><Link to="/event-single">Health</Link></li>
                    </ul>
                </div> */}
            </div>
        </div>
     )
        
}

export default SidebarWrap;
